import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=21ad17f7&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=ts&"
export * from "./BasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=21ad17f7&prod&lang=scss&scoped=true&"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&id=21ad17f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad17f7",
  null
  
)

export default component.exports